module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_8011.c5aec6d8.png";